// apps/web/src/shared/pickChangedFields.ts
// Spec §14.4. PATCH-diff helper — produce a minimal patch object that only
// includes `allowedKeys` whose new value is defined AND differs from baseline.
export function pickChangedFields<T extends Record<string, unknown>>(
  values: T,
  baseline: T,
  allowedKeys: (keyof T)[],
): Partial<T> {
  const out: Partial<T> = {};
  for (const k of allowedKeys) {
    const v = values[k];
    if (v !== undefined && v !== baseline[k]) out[k] = v;
  }
  return out;
}
